import { DetailPageActionTypes } from './constants'
import { Dispatch } from 'redux'
import { store } from '../store'
import { Logger } from 'DVWebNodeUtils'
import { purchaseSelector } from '../selectors/purchase'
import { safeBoolean, COUNTER_PACKAGE_PREFIX } from '../utils/utils'
import { DetailPageActions } from './index'
import { CallbackInput } from '../components/purchaseFlowWrapper/purchaseFlowWrapper'
import { refreshActionBoxes } from './actionBox'

const LOG_PREFIX = '[Purchase]'

export interface ITriggerPurchase {
  type: typeof DetailPageActionTypes.TriggerPurchase
  payload: {
    offerToken: string
    continueToken?: string
    refTag?: string
  }
}

export interface IPurchaseCancelled {
  type: typeof DetailPageActionTypes.PurchaseCancelled
}

export interface IPurchaseFailed {
  type: typeof DetailPageActionTypes.PurchaseFailed
  payload: {
    reload: boolean
  }
}

export const triggerPurchase = (
  dispatch: Dispatch<DetailPageActions>,
  logger: Logger,
  offerToken: string,
  continueToken?: string,
  refTag?: string
) => {
  logger
    .info(`${LOG_PREFIX} - Initiating purchase of offerToken ${offerToken}`)
    .count(
      `${COUNTER_PACKAGE_PREFIX}_Purchase_${
        continueToken ? 'continue' : 'start'
      }Purchase`,
      1,
      false
    )
  dispatch({
    type: DetailPageActionTypes.TriggerPurchase,
    payload: {
      offerToken,
      continueToken,
      refTag,
    },
  })
}

export const purchaseCancelled = ({ dispatch }: CallbackInput) =>
  dispatch({ type: DetailPageActionTypes.PurchaseCancelled })

export const purchaseFailed = ({
  dispatch,
  reload = false,
}: CallbackInput & { reload?: boolean }) =>
  dispatch({
    type: DetailPageActionTypes.PurchaseFailed,
    payload: { reload },
  })

export const refreshAfterDone = ({ logger }: CallbackInput) => {
  const state = store.getState()
  const purchaseDetails = purchaseSelector(state)
  if (!purchaseDetails) {
    logger
      .fatal(`${LOG_PREFIX} - No ongoing purchase found`)
      .count(`${COUNTER_PACKAGE_PREFIX}_Purchase_refreshAfterDoneError`, 1, true)
  }

  const details = purchaseDetails && purchaseDetails.details
  const uniqueTitleToRefresh = details &&
    !safeBoolean(details.offer.purchaseData.isSeasonPurchase) &&
    details.canonicalId || undefined
  return refreshActionBoxes(uniqueTitleToRefresh)
}

let lastOfferTokenPurchased: string | null = null
export const refreshCSRF = async ({ dispatch, logger }: CallbackInput) => {
  const { purchase } = store.getState()

  if (!purchase) {
    return
  }

  const { offerToken, continueToken, refTag } = purchase
  if (offerToken !== lastOfferTokenPurchased) {
    lastOfferTokenPurchased = offerToken
    await refreshActionBoxes()
    triggerPurchase(dispatch, logger, offerToken, continueToken, refTag)
  } else {
    //Protection to avoid entering into an endless callback loop
    logger
      .fatal(
        `${LOG_PREFIX} - CSRF Callback already called once for offerToken ${offerToken}`
      )
      .count(`${COUNTER_PACKAGE_PREFIX}_Purchase_refreshCSRFError`, 1, true)
    lastOfferTokenPurchased = null
    purchaseFailed({ dispatch, logger, reload: true })
  }
}
